let facebookSdkPromise;

export function loadFacebookSdk() {
    if (window.FB) {
        return Promise.resolve(window.FB);
    }

    if (facebookSdkPromise) {
        return facebookSdkPromise;
    }

    facebookSdkPromise = new Promise((resolve, reject) => {
        window.fbAsyncInit = () => {
            window.FB.init({
                appId: import.meta.env.VITE_META_APP_ID,
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v19.0',
            });
            resolve(window.FB);
        };

        const existingScript = document.getElementById('facebook-jssdk');
        if (existingScript) {
            existingScript.addEventListener('error', () => reject(new Error('Facebook SDK failed to load')), {once: true});
            return;
        }

        const script = document.createElement('script');
        script.id = 'facebook-jssdk';
        script.src = 'https://connect.facebook.net/en_US/sdk.js';
        script.async = true;
        script.defer = true;
        script.addEventListener('error', () => {
            script.remove();
            facebookSdkPromise = undefined;
            reject(new Error('Facebook SDK failed to load'));
        }, {once: true});
        document.head.appendChild(script);
    });

    return facebookSdkPromise;
}
